module.exports = __webpack_public_path__ + "static/media/ship2.3b0c5b00.png";